/** Shown on the settings sheet. Keep in step with package.json. */
export const APP_VERSION = '0.1.0';
